import { useMemo, useState } from 'react'
import { Typography } from 'antd'
import { DownOutlined, UpOutlined } from '@ant-design/icons'

import { stripHtml } from '../../../Helpers/StringHelpers'
import { ArticleColumn } from '../../../Constants/TableConfiguration'

const { Paragraph } = Typography

function DynamicParagraph(props) {
  const [expand, setExpand] = useState(false)
  const [counter, setCounter] = useState(0)

  const text = useMemo(() => {
    return props.language ? stripHtml(props.text) : props.text
  }, [props.language, props.text])
  const rows = useMemo(() => {
    return props.colName === ArticleColumn.ProductDescription || props.language ? 2 : 1
  }, [props.colName, props.language])

  return (
    <div key={counter}>
      <Paragraph
        className='margin-0'
        style={{ width: props.elementWidth }}
        ellipsis={{
          rows: rows,
          expandable: true,
          symbol: (
            <span className='expand-icon'>
              <DownOutlined />
            </span>
          ),
          onExpand: e => {
            e.stopPropagation()
            setExpand(true)
          },
        }}
      >
        {text}
      </Paragraph>
      {expand && (
        <span className='expand-icon'>
          <UpOutlined
            onClick={e => {
              e.stopPropagation()
              setExpand(false)
              setCounter(counter + 1)
            }}
          />
        </span>
      )}
    </div>
  )
}

export default DynamicParagraph
